<div class="p-grid container" style="padding: 15px;">
    <div class="p-grid" [class]="(cq === true || readonly === true)? 'p-col-7':'p-col-10'">

    </div>
    <div class="p-col-2">
        <div class="p-grid">
            <div class="p-col-12">
                <p-checkbox [binary]="true" [disabled]=" disableDoute() " [name]="douteName" [(ngModel)]="isDoute" label="Doute sur contenu" (onChange)="doute(isDoute)"></p-checkbox>
                <i class="pi pi-exclamation-triangle" *ngIf="isDoute" style="font-size: large; font-weight: bold; color: orangered; margin: 15px; float: right;"></i>
            </div>
        </div>
    </div>

    <div class="p-grid p-col-12">       
        <div [class]="(cq === true || readonly === true)? 'p-col-6':'p-col-9'">
            <div class="p-grid">
                <textarea #description spellcheck="true" class="p-col-12" *ngIf="contenuFormated"  [rows]="5" pInputTextarea style="width:100%" [disabled] = "disabledTextArea" [(ngModel)]="contenuFormated" (ngModelChange)="descriptionChanged(contenuFormated)"></textarea>
                
                <div [class]="(cq === true || readonly === true)? 'p-col-6':'p-col-3'">
                    <strong [style]="((getNbOfCharachter() > 800  || getNbOfCharachter() <  100)? 'color :tomato;' : 'color : lightgreen')">{{getNbOfCharachter()}}</strong> caractères sur <strong>800</strong> autorisés
                </div>

                <!-- <div class="p-col-3">
                    <button pButton ngxClipboard [cbContent]="contenuFormated" type="button" icon="pi pi-copy" label="Copier texte" style="width: 100%; background-color: steelblue; border-color: steelblue;" (click)="descriptifCopied(contenuFormated)"></button>
                </div> -->

                <div class="p-col-3">
                    <button pButton type="button" label="Google" style="width: 100%; background-color: steelblue; border-color: steelblue;" (click)="redirectToGoogle(contenuFormated)"></button>
                </div>

                <div class="p-col-3">
                    <button pButton ngxClipboard [cbContent]="contenuFormated" type="button" label="Antidote" style="width: 100%; background-color: steelblue; border-color: steelblue;" (click)="openAntidote(contenuFormated)"></button>
                </div>
                <!-- <ng-template [ngIf]="(!cq && !readonly)">
                    <div class="p-col-3">
                        <button pButton type="button" [label]="btnModifierLabel" style="width: 100%; background-color: steelblue; border-color: steelblue;" (click)="setEditable()"></button>
                    </div>
                </ng-template> -->
            </div>
        </div>

        
        <div class="p-col-1">
            <div style="border-left:1px solid darkgrey;height:100%; width:0; margin:auto; border-width: medium;"></div>
        </div>

        <div class="p-col-2">
            <div class="p-grid">
                <ng-template [ngIf]="duplicate === false">
                    <div class="p-col-12" style="text-align: left;">
                        <h4>Statut</h4>
                        <div class="p-grid" style="width:100%;margin: auto">
                            <div class="p-col-6"><p-radioButton [disabled]="disableModeration()" [name]="validName" [value]="true" label="OK" [(ngModel)]="valid" (ngModelChange)="validChanged(valid)" inputId="is_valid"></p-radioButton></div>
                            <div class="p-col-6"><p-radioButton [disabled]="disableModeration()" [name]="validName" [value]="false" label="KO" [(ngModel)]="valid" (ngModelChange)="validChanged(valid)" inputId="non_valid"></p-radioButton></div>
                        </div>
                    </div>
                    <ng-template [ngIf]="valid === false">
                        <div class="p-col-12" >
                            <app-erreurs [cq]=" disableModeration()" [selected-errors]="selectedErrors" [error-list]="errors" (errorsChangedEvent)="setErrors($event)"></app-erreurs>
                        </div>
                    </ng-template>

                </ng-template>

        

                <ng-template [ngIf]="motifs.length > 0">
                    <div class="p-col-12">
                        <h4>Motif(s) :</h4>
                        <ul>
                            <li *ngFor="let motif of motifs">
                                {{motif["designation_motif"]}}
                            </li>
                        </ul>
                    </div>
                </ng-template>

                <ng-template [ngIf]="motifsCq.length > 0 && cq === false">
                    <hr width="100%" style="display: block; height: 1px;border: 0; border-top: 1px solid #ccc; margin: 1em 0; padding: 0;">
                    <div class="p-col-12" style="font-weight: bold; color: tomato;">
                        <h4>Motif(s) KO CQ:</h4>
                        <ul>
                            <li *ngFor="let motif of motifsCq">
                                {{motif["designation_motif"]}}
                            </li>
                        </ul>
                    </div>
                </ng-template>
                <ng-template [ngIf]="motifsCq.length === 0 && cq === false && validationCQ === false" >
                        <h4 style="font-weight: bold; color: tomato;text-align: center;width: 100%;">KO CQ : Décision non conforme</h4>
                </ng-template>
                
            </div>
        </div>

       <ng-template [ngIf]="(cq === true || readonly === true)">
            <div class="p-col-1">
                <div style="border-left:1px solid darkgrey;height:100%; width:0; margin:auto; border-width: medium;"></div>
            </div>

            <div class="p-col-2">
                <div class="p-grid">
                    <div class="p-col-12" style="text-align: left;">
                        <h4>CQ</h4>
                        <div class="p-grid" style="width:100%;margin: auto">
                            <div class="p-col-6"><p-radioButton  [disabled]="readonly" [name]="cqName" [value]="true" label="C" [(ngModel)]="validationCQ" inputId="is_valid" (ngModelChange)="validCqChanged(validationCQ)"></p-radioButton></div>
                            <div class="p-col-6"><p-radioButton  [disabled]="readonly" [name]="cqName" [value]="false" label="NC" [(ngModel)]="validationCQ" inputId="non_valid" (ngModelChange)="validCqChanged(validationCQ)"></p-radioButton></div>
                        </div>
                    </div>
                    <ng-template [ngIf]="validationCQ === false">
                        <div class="p-col-12" >
                            <app-erreurs [cq]="readonly" [error-list]="errors" (errorsChangedEvent)="setCqErrors($event)"></app-erreurs>
                        </div>
                    </ng-template>

                    <ng-template [ngIf]="motifsCq.length > 0">
                        <div class="p-col-12">
                            <h4>Sur les motifs :</h4>
                            <ul>
                                <li *ngFor="let motif of motifsCq">
                                    {{motif["designation_motif"]}}
                                </li>
                            </ul>
                        </div>
                    </ng-template>

                    
                </div>
            </div>
       </ng-template>
        
        
    </div>

    <div class="p-col-12">
        <div class="p-grid">
            <div class="p-col-2 p-offset-5">
            </div>
        </div>
    </div>

    <!-- PARTIE ETATS ANTERIEURS-->
    <div class="p-col-12" style="margin-top: 15px;" *ngIf="ContenusAnterieurs.length > 0 && isRetour">
        <hr style="margin : 15px 15%;">
        <h2 style="text-align: center;">HISTORIQUE</h2>
        <div *ngFor="let current of ContenusAnterieurs" class="p-grid historique" style="margin-top: 15px;">
            <div class="p-col-12">
                <div class="p-grid">
                    <div class="p-col-2"> <strong> Type  : {{ current['designation_type_ptl'] }} </strong> </div> 
                    <div class="p-col-2"> <strong> Etape  : {{ (current['id_action'] === 5) ? 'CQ' : 'Modération' }} </strong> </div>
                    <div class="p-col-2"> <strong> Statut : {{ (current['id_action'] === 5) ? ( (current['is_valid_cq']) ? 'OK' : 'KO' ) : ( (current['is_valid']) ? 'OK' : 'KO' ) }}</strong> </div>
                    <div class="p-col-4"> <strong> Action effectuée le  : {{ current['date_action']  }} </strong> </div>
                </div>
            </div>
            <div class="p-col-9">
                <textarea class="p-col-12"  [rows]="5" pInputTextarea style="width:100%" [disabled] = "true" [(ngModel)]="current['valeur_contenu']"></textarea>
            </div>
            <div class="p-col-3">

                <div style="width: 100%;" *ngIf="current['id_action'] === 2 && current['erreurs'].length > 0 ">
                    <ul>
                        <li *ngFor="let motif of current['erreurs'] ">
                                {{motif['designation_motif'] }}
                        </li>
                    </ul>
                </div>

                <div style="width: 100%;" *ngIf="current['id_action'] === 5 && current['erreurs_cq'].length > 0 ">
                    <ul>
                        <li *ngFor="let motif of current['erreurs_cq'] ">
                                {{motif['designation_motif'] }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <!-- FIN ETATS ANTERIEURS -->

</div>


<p-toast [styleClass]="'message'">
    <ng-template let-message pTemplate="message">
        <div style="text-align: center">
            <i class="pi pi-info-circle" style="font-size: 12px; font-weight: bold; "></i>
            <h3 style="font-size: small;">{{message.summary}}</h3>
            <p>{{message.detail}}</p>
        </div>
    </ng-template>
</p-toast>

